module.exports = __webpack_public_path__ + "media/images/zebra-left-312e279c287426fe718f87572487f373.png";